export { InfiniteRowModelModule } from "./infiniteRowModelModule";